export default __webpack_public_path__ + "static/media/shop_react_redux.4507f49d.png";